module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer hidden-print",
    attrs: {
      "id": "footer",
      "role": "footer"
    }
  }, [_c('div', {
    staticClass: "wrapper b-t bg-light"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_vm._v("0.0.1 "), _c('a', {
    staticClass: "m-l-sm text-muted"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-up"
  })])]), _vm._v(" IntranetCorp Wtis © 2017 Copyright. ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78476b5f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/Footer.vue
// module id = 829
// module chunks = 2